import { render, staticRenderFns } from "./_report_id.vue?vue&type=template&id=187d8bb0&"
import script from "./_report_id.vue?vue&type=script&lang=js&"
export * from "./_report_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports